import { filter, take, repeat, map, takeWhile, toArray } from 'rxjs/operators'
import { fromEvent, zip, from } from 'rxjs'
import { AlertFactory } from 'alerts/Alert'

/**
 * Comic Sans Protocol.
 *
 * @param newAlert
 */
export function ComicSansProtocol(newAlert: AlertFactory) {
  // Keyboard codes for Konami.
  const konamiCode = [38, 38, 40, 40, 37, 39, 37, 39, 66, 65]
  // Zip the konami code and keypresses
  zip(
    from(konamiCode),
    fromEvent<KeyboardEvent>(window.document, 'keyup').pipe(
      map((x) => x.keyCode),
    ),
  )
    .pipe(
      // Map whether the entry in the Konami code matches
      // the keystroke..
      map(([left, right]) => left === right),
      // Take while it does.
      takeWhile(Boolean),
      // Until we've got all of them.
      take(konamiCode.length),
      // At this point, it will be
      // an array of `true`s.
      toArray(),
      // It could also be a partial match, so filter those out.
      filter((arr) => arr.length === konamiCode.length),
      // Restart the whole thing on complete.
      repeat(),
    )
    .subscribe(() => {
      const protocol = 'comic-sans-protocol'
      if (document.body.classList.contains(protocol)) {
        newAlert()
          .autoDismiss()
          .saying(
            'Comic Sans Protocol Disengaged',
            'Big Chungus is displeased with this decision.',
          )
          .show()
      } else {
        newAlert()
          .autoDismiss()
          .saying(
            'Comic Sans Protocol Engaged',
            'Enjoy Work Portal the way Big Chungus intended!',
          )
          .show()
      }
      document.body.classList.toggle(protocol)
    })
}
